// extracted by mini-css-extract-plugin
export default {"field":"oDKUoW","input":"XEAukw","switchLabel":"P29pqV","label":"n0cNdD","horizontal":"wO5djA","button":"umayH4"};